module.exports = __webpack_public_path__ + "static/media/pic_success.9936afac.svg";